import React from "react";
import Context from "../../../Context";
import SuperSelect from "../../Misc/SuperSelect";
import Searchbox from "../../Misc/Searchbox";
import ElementTree from "./ElementTree";
import Blocker from "../../Misc/Blocker";

export default class ElementTreeList extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      elements: {},
      textSearchValue: "",
      pending: false,
      critical: false,
      manager: false,
    };
  }

  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.specId !== this.props.specId ||
      prevProps.shipId !== this.props.shipId ||
      prevProps.customListKey !== this.props.customListKey
    ) {
      this.load();
    }
  }

  load = async () => {
    this.setState({ pending: true });

    let elementFilters = [];

    let shipId =
      this.props.shipId && this.props.shipId !== "any"
        ? this.props.shipId
        : null;

    elementFilters.push({
      field: "ship",
      compare: "EQL",
      value: shipId,
    });

    if (this.state.critical) {
      elementFilters.push({
        field: "critical",
        compare: "EQL",
        value: true,
      });
    }

    if (this.state.manager) {
      elementFilters.push({
        field: "manager",
        compare: "EQL",
        value: this.state.manager,
      });
    }

    if (this.state.textSearchValue) {
      elementFilters.push(
        {
          lstr: "(",
          field: "label",
          compare: "IKE",
          value: `%${this.state.textSearchValue}%`,
        },
        {
          condition: "OR",
          field: "modelname",
          compare: "IKE",
          value: `%${this.state.textSearchValue}%`,
          rstr: ")",
        }
      );
    }

    if (this.props.specId && this.props.specId !== "any") {
      elementFilters.push({
        field: "specification",
        compare: "EQL",
        value: this.props.specId,
      });
    }

    let elements = await this.context.api.qoo(
      `/element/tree`,
      {
        fields: [
          "id",
          "parent",
          "level",
          "label",
          "modelname",
          "critical",
          "count",
        ],
        search: elementFilters,
        reclimit: 0,
        orderby: ["sortlist"],
      },
      undefined,
      undefined,
      undefined,
      "parent",
      "sequence"
    );
    this.setState({ pending: false, elements });
  };

  handleSearch = (textSearchValue) => {
    this.setState({ textSearchValue }, () => this.load());
  };

  toggleCritical = () => {
    this.setState(
      (state) => {
        return { critical: !state.critical };
      },
      () => this.load()
    );
  };

  changeManager = (manager) => {
    this.setState({ manager }, () => this.load());
  };

  render() {
    const { elements, critical, manager, textSearchValue } = this.state;
    let search = critical || manager || textSearchValue;

    let displayItems = {};
    if (search) {
      Object.entries(elements).forEach(([id, item]) => {
        displayItems[id] = { ...item, parent: null, level: 1 };
      });
    } else {
      displayItems = elements;
    }

    return (
      <>
        <div
          className="mb-4"
          onScroll={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <SuperSelect
            grey
            defaultValue={this.state.manager}
            onChange={this.changeManager}
            essence="staff"
            placeholder="По заведующему..."
            nameField="label"
            idField="id"
            isClearable
            orderby={["label ASC"]}
          />
        </div>
        <div className="d-flex mb-4">
          <div className="text-nowrap flex-grow-1 mr-2">
            <Searchbox
              onSearch={this.handleSearch}
              defaultText={this.state.textSearchValue}
            />
          </div>
          <div>
            <button
              title="Критическое оборудование"
              className="btn btn-icon btn-light"
              onClick={this.toggleCritical}
            >
              <i
                className={`fa fa-exclamation-triangle ${
                  this.state.critical && "text-danger"
                }`}
              ></i>
            </button>
            {this.props.extraButtons}
          </div>
        </div>
        <Blocker on={this.state.pending}>
          <ElementTree items={displayItems} {...this.props} />
        </Blocker>
      </>
    );
  }
}
